export function addCurrent(articlessection) {
    return {
        type: 'ADD_CURRENT',
        articlessection,
    }
}
